import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/app/components/ui/toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/wrapper-client-body.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/nextjs-toploader/dist/index.js");
